module.exports = __webpack_public_path__ + "img/standard-icon3.1860ee0.svg";